<template>
    <div>
        <breadCrumb
            :icon="'fa-calendar-alt'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_appointment`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <!-- <button v-b-toggle.addAppointmentModal class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}}</span>
            </button> -->
            <!-- <button v-b-toggle.addAppointmentWizard class="btn ml-1 buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}} Wizard(Dummy)</span>
            </button> -->
            <!-- <button v-b-modal.addAppointmentModalX class="btn ml-1 buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}}</span>
            </button> -->
            <div>
                <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                    <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.appointmentTabs" :key="t.id">
                        <a class="nav-link bg-transparent fs-lg fw-400" :class="{ 'active': selectedTab == t.id }" @click="selectedTab = t.id">{{ t.text
                        }}</a>
                    </li>
                </ul>
                <div class="px-1 px-sm-5 py-4">
                    <div class="panel mb-0">
                        <div class="panel-hdr d-block pt-4 p-1">
                            <appointmentFilter
                                ref="appointmentFilter"
                                @selectedOutlet="selectOutlet"
                                @skuList="skuTrigger"
                                @openAddModal="openAddModal"
                                @openEditModal="openEditModal"
                                :COLOR_CONST_RAW="COLOR_CONST_RAW"
                                :tab="selectedTab">
                            </appointmentFilter>
                        </div>
                        <div class="panel-container show">
                            <div class="panel-content">
                                <div class="tab-content mt-5">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <AddModal :sku="sku" /> -->
        <AddModalX ref="dataModal" :selectedOutlet="selectedOutlet" @apptCreated="apptCreated" :COLOR_CONST_RAW="COLOR_CONST_RAW" />
        <!-- <AddWizard :sku="sku" /> -->
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import AppointmentFilter from './Appointment_Filter'
import AddModal from './Appointment_Add_Modal'
import AddModalX from './Appointment_Add_ModalX'
import AddWizard from './Appointment_Add_Wizard'
import {
    handleSessionExpired,
} from "../../../../assets/js/dashboard/dashboard";
export default {
    name: 'MenuAppointment',
    components: {
        BreadCrumb,
        AppointmentFilter,

        // AddWizard,
        AddModalX,
    },
    data() {
        return {
            addToggle: false,
            selectedTab: 'calendar',
            sku: [],
            selectedOutlet: {},

            COLOR_CONST_RAW: [
                this.hsv_to_hsl(6, 74, 91),
                this.hsv_to_hsl(24, 100, 83),
                this.hsv_to_hsl(40, 100, 100),
                this.hsv_to_hsl(145, 77, 80),
                this.hsv_to_hsl(204, 76, 86),
                this.hsv_to_hsl(253, 56, 64),
                this.hsv_to_hsl(327, 57, 83),
                this.hsv_to_hsl(74, 81, 69),
                this.hsv_to_hsl(168, 86, 63),
                this.hsv_to_hsl(0, 0, 15),
                this.hsv_to_hsl(25, 34, 56),
                this.hsv_to_hsl(196, 54, 45),
                this.hsv_to_hsl(204, 5, 78),
                '#384D82',
            ],
        }
    },
    methods: {
        skuTrigger(res) {
            this.sku = res;
        },
        selectOutlet(sel) {
            this.selectedOutlet = sel;
        },
        apptCreated(event) {
            this.$refs.appointmentFilter.setAppointmentList()
        },
        openAddModal(date, staffID, outletID) {
            this.$refs['dataModal'].show(null, date, staffID, outletID)
        },
        openEditModal(data) {
            this.$refs['dataModal'].show(data)
        },
        hsv_to_hsl(h, s, v) {
            // both hsv and hsl values are in [0, 1]
            s = s / 100;
            v = v / 100;
            var l = (2 - s) * v / 2;
            if (l != 0) {
                if (l == 1) {
                s = 0
                } else if (l < 0.5) {
                s = s * v / (l * 2)
                } else {
                s = s * v / (2 - l * 2)
                }
            }
            // return [h, s, l]

            // var l = (2 - s) * v / 2;
            // s = l&&l<1 ? s*v/(l<0.5 ? l*2 : 2-l*2) : s;

            return `hsl(${h.toFixed(2)}, ${(s * 100).toFixed(2)}%, ${(l * 100).toFixed(2)}%)`;
        },
    },
}
</script>